import React, { ReactNode, useMemo } from "react";
import { Avatar, Col, Row, Skeleton, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import ColorHash from "color-hash";
// import ColorHash from "color-hash";
const { Text } = Typography;
type Props = {
  username: string;
  isLoading: boolean;
  alt?: string | undefined;
  src?: string | ReactNode | undefined;
  gap?: number;
  icon?: ReactNode | string | undefined;
  shape?: "circle" | "square";
  size?: number | "large" | "small" | "default" | {};
  style?: React.CSSProperties | undefined;
};

const styles = {
  avatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
const AvatarUsername = ({
  username,
  isLoading,
  src = "",
  alt = "Avatar",
  gap = 4,
  icon = <UserOutlined />,
  shape = "circle",
  size = 30,
  style = { width: "100%" },
}: Props) => {
  const letter = useMemo(() => {
    if (username.length > 0) {
      return username
        .trim()
        .split(" ")
        .slice(-1)
        .toString()
        .charAt(0)
        .toUpperCase();
    } else {
      return "";
    }
  }, [username]);

  const backgroundColor = useMemo(() => {
    return new ColorHash().hex(username);
  }, [username]);

  const avatar = (
    <Avatar style={{ backgroundColor: backgroundColor }}>{letter}</Avatar>
  );
  return (
    <div style={{ ...style }}>
      {isLoading ? (
        <Skeleton avatar paragraph={{ rows: 0 }} />
      ) : (
        <Row gutter={[8, 0]} justify={"start"} align={"middle"}>
          <Col>
            {avatar}
            {/* <Avatar
              size={size}
              icon={icon}
              shape={shape}
              gap={gap}
              alt={alt}
              src={src}
              style={{ ...styles.avatar }}
            /> */}
          </Col>
          <Col>
            <Text>{username}</Text>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default AvatarUsername;
